<template>
    <div class="portlet-body">
        <div class="row">
            <div class="col-md-7">
                <!-- text -->
                <div class="outside-text-wrapper">

                    <div class="portlet-title-testdrive">
                        ΕΡΩΤΗΣΗ {{ question.index }}
                    </div>

                    <div class="text-wrapper" @click="playSound(question.sound)">
                        <div class="text">
                            {{ question.text }}
                        </div>
                    </div>
                </div>

                <div class="image visible-xs visible-sm">
                    <img :src="question.image" alt=""
                         @click="isZoomed=!isZoomed"
                         :class='{zoomed: isZoomed}'
                         v-if="question.image">
                </div>


                <!-- options -->
                <div class="options-wrapper">

                    <transition-group name="options" tag="div" appear>
                        <div class="option" v-for="option in question.options" :key="option.id"
                             @click="selectOption(option)"
                             @dblclick="answer"
                             :class="{
                             active: (!question.selectedOption &&  question.tempSelectedOption === option),
                             wrong: (question.selectedOption && (!question.isCorrect() && question.selectedOption === option )),
                             correct: (question.selectedOption && (!question.isCorrect() && option.is_correct ))
                             }" role="button">
                            {{ option.text }}
                        </div>
                    </transition-group>

                </div>
            </div>


            <div class="col-md-offset-1 col-md-4">
                <!-- image -->
                <div class="image hidden-xs hidden-sm">
                    <img :src="question.image" alt=""
                         @click="isZoomed=!isZoomed"
                         @mouseleave="isZoomed=false"
                         :class='{zoomed: isZoomed}'
                         v-if="question.image">
                </div>


                <!-- buttons -->
                <div class="buttons">

                    <!-- box timer for testdrive theme -->
                    <div class="box-timer-wrapper" v-if="theme==='testdrive'">
                        <div class="box-timer">
                            <div class="box-timer xronos"></div>
                            <div class="box-timer wrapper">
                                <div class="box-timer percentage" :style="{width: timerWidth+'%'}"></div>
                            </div>
                        </div>
                    </div>

                    <div class=" hidden-xs hidden-sm">
                        <button class="btn answer "
                                @click="answer"
                                :disabled="!question.tempSelectedOption || question.selectedOption">
                            ΕΠΙΒΕΒΑΙΩΣΗ <i class="fa fa-check-square-o" aria-hidden="true"></i>
                        </button>
                        <button class="btn skip"
                                @click="skip"
                                :disabled="(!questionsLeft && !question.selectedOption)"
                                :class="{active: question.selectedOption && !question.selectedOption.is_correct }">
                            ΕΠΟΜΕΝΗ <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>

                <!-- buttons for mobile s-->
                <div class="buttons mobile visible-xs visible-sm">
                    <div class="row">
                        <div :class="(!question.selectedOption || question.selectedOption.is_correct)?'col-xs-5' : 'col-xs-12'">
                            <button class="btn skip"
                                    @click="skip"
                                    :disabled="(!questionsLeft && !question.selectedOption)"
                                    :class="{active: question.selectedOption && !question.selectedOption.is_correct }">
                                ΕΠΟΜΕΝΗ <i class="fa fa-arrow-right" aria-hidden="true"></i>
                            </button>
                        </div>

                        <div class="col-xs-7" :class="{hidden: question.selectedOption && !question.selectedOption.is_correct }">
                            <button class="btn answer"
                                    @click="answer"
                                    :disabled="!question.tempSelectedOption || question.selectedOption">
                                ΕΠΙΒΕΒΑΙΩΣΗ <i class="fa fa-check-square-o" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    /**
     * every question instance has a _active for current translation
     * and a this.tempSelectedOption, this.selectedOption to hold
     * the currently temporarily selected answer and after answer
     * confirmation it holds in selectedOption the choosen answer
     * ! the tempSelectedOption clears when a changeLang() request
     * is fired, so it clears the currently selected answer.
     *
     * every question is a reference to the original currentQuestion
     * from the drivingTest component. We then pass it to the
     * questionList compomnent to display the results.     *
     */

    export default {
        data() {
            return {
                selected:   null,
                isZoomed:   false,
                answerSent: false
            };
        },
        props:   ['question', 'withSound', 'questionsLeft', 'timerWidth', 'theme'],
        methods: {
            selectOption(option) {
                this.question.tempSelectedOption = option;
                this.playSound(option.sound);
            },
            answer() {
                if (!this.question.tempSelectedOption || this.answerSent) return;
                this.question.answerWithSelected();
                this.answerSent = true;
                this.$emit('answer');
            },
            skip() {
                this.question.tempSelectedOption = null;
                this.$emit('skip');
            },
            playSound(sound) {
                this.$emit('playSound', sound);
            },
            stopSound() {
                this.$emit('playSound', null);
            }
        },
        watch:   {
            question() {
                this.isZoomed   = false;
                this.selected   = null;
                this.answerSent = false;
                this.stopSound();
                this.playSound(this.question.sound);
            }
        },
        mounted() {
            this.playSound(this.question.sound);
        }
    };
</script>